export default "__VITE_ASSET__29040297__"